import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { InitialStateType, Meta, WebHookSource } from 'src/redux/job-details/types';
import { getWebHooks } from 'src/redux/job-details/api';
import { defaultWebHookDetails } from 'src/redux/job-details/slice';

const extraReducers = (builder: ActionReducerMapBuilder<InitialStateType>) => {
  builder
    .addCase(
      getWebHooks().fulfilled,
      (state: InitialStateType, action: PayloadAction<{
        data: WebHookSource[],
        meta: Meta,
        link: {}
      }>) => {
        const { data, meta } = action.payload;
        const newSource:Record<string, WebHookSource> = {};
        const newHookIds:Array<string> = [];
        data?.forEach((item:WebHookSource) => {
          if (item?.webhook_log_id) {
            newHookIds.push(item?.webhook_log_id);
            newSource[item?.webhook_log_id] = {
              ...(item || {}),
            };
          }
        });

        state.webHookDetails = {
          data: newHookIds,
          meta: meta || {},
        };
        state.source = newSource;
      },
    )
    .addCase(
      getWebHooks().rejected,
      (state: InitialStateType) => {
        state.webHookDetails = defaultWebHookDetails;
      },
    );
};

export default extraReducers;
